import {
  CLEAN_FEEDBACK_STORE,
  FLAG_MESSAGE,
  FLAG_MESSAGE_ERROR,
  FLAG_MESSAGE_SUCCESS,
  MANAGE_POPUP,
} from './constants';

const INITIAL_STATE = {
  popup: {
    opened: false,
    view: 'options',
    position: { top: 0, left: 0 },
  },
  loading: false,
  error: null,
};

const feedbackReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case FLAG_MESSAGE:
      return {
        ...state,
        loading: true,
      };
    case FLAG_MESSAGE_SUCCESS:
      return {
        ...state,
        loading: false,
        optionSaved: action.payload,
      };
    case FLAG_MESSAGE_ERROR:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    case MANAGE_POPUP:
      return {
        ...state,
        popup: { ...state.popup, ...action.payload },
      };
    case CLEAN_FEEDBACK_STORE:
      return INITIAL_STATE;
    default:
      return state;
  }
};

export default feedbackReducer;
